import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'csl-inside-cut-input',
  templateUrl: './inside-cut-input.component.html',
})
export class InsideCutInputComponent {
  _X = 0;
  _Y = 0;
  _R = 0;

  variableParamsChanged$: Observable<unknown>;

  @Input() editable = true;

  @Input() xMax = 0;
  @Input() xMin = 0;
  @Input() yMax = 0;
  @Input() yMin = 0;
  @Input() rMax = 0;
  @Input() rMin = 0;

  @Output() xChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set x(value: number) {
    this._X = value;
  }

  @Output() yChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set y(value: number) {
    this._Y = value;
  }

  @Output() rChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set r(value: number) {
    this._R = value;
  }

  @Input()
  get dense() {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  paramChanged(eventEmitter: EventEmitter<number>, param: 'R' | 'X' | 'Y', value: number) {
    this[`_${param}`] = value;

    eventEmitter.next(value);
  }
}
